import EntryDetail from './EntryDetail';
import EntryList from './EntryList';
import StaticContent from './StaticContent';

const contentful = {
  EntryDetail,
  EntryList,
  StaticContent,
};

export default contentful;